import L, { type LatLngExpression } from 'leaflet'
import type {
  AddressCardFragment,
  MediaImageFragment,
  MediaCantoFragment,
} from '#graphql-operations'

export const MIN_ZOOM = 9
export const MAX_ZOOM = 20
export const INITIAL_ZOOM = 12
export const CENTER_ZUERICH: [number, number] = [47.372683, 8.537058]
export const CENTER_RAPPERSWIL: [number, number] = [
  8.830939234375258, 47.22769067694721,
]

export interface LatLon {
  lat: number
  lon: number
}

export interface FeatureItem {
  latlon: LatLon
  title: string
  subtitle: string
}

export interface MapPoiFeature {
  id: string
  title: string
  lat: number
  lon: number
  media?: MediaImageFragment | MediaCantoFragment | object | null
  url?: string
  address?: AddressCardFragment
}

export class MapMarker extends L.Marker {
  data: MapPoiFeature

  constructor(
    latLng: LatLngExpression,
    options: L.MarkerOptions,
    data: MapPoiFeature,
  ) {
    super(latLng, options)
    this.data = data
  }

  openParentCluster() {
    try {
      // @ts-ignore
      if (!this._icon) {
        // @ts-ignore
        const cluster: MarkerCluster = this.__parent

        if (cluster) {
          cluster.spiderfy()
        }
      }
    } catch {
      // Noop.
    }
  }

  setActive(): this {
    const element = this.getElement()
    if (element) {
      element.classList.add('is-active')
    }
    return this
  }

  setInactive(): this {
    const element = this.getElement()
    if (element) {
      element.classList.remove('is-active')
    }
    return this
  }
}
